import { Stack } from "@mui/material";
import { type UseModalState } from "@src/lib/ui-react";

import { Button } from "../../../components/Button";
import { Dialog } from "../../../components/Dialog";
import { Text } from "../../../components/Text";
import { LOCK_EXPIRY_DAYS } from "../constants";

interface LockedByOtherDialogProps {
  modalState: UseModalState;
}

export function LockedByOtherDialog(props: LockedByOtherDialogProps) {
  const { modalState } = props;

  return (
    <Dialog modalState={modalState} title="Professional's account locked">
      <Stack gap={3}>
        <Text>
          This professional&apos;s account has been locked by another workplace. While locked, this
          professional:
        </Text>
        <Stack component="ul" gap={1} sx={{ margin: 0, paddingLeft: 4 }}>
          <li>
            <Text>Cannot accept new Home Health visits</Text>
          </li>
          <li>
            <Text>Cannot be assigned to new cases</Text>
          </li>
        </Stack>
        <Text>The lock will expire automatically after {LOCK_EXPIRY_DAYS} days.</Text>
      </Stack>
      <Stack direction="row" justifyContent="flex-end" sx={{ marginTop: 4 }}>
        <Button variant="outlined" onClick={modalState.closeModal}>
          OK
        </Button>
      </Stack>
    </Dialog>
  );
}
